import {
  IconAddressBook,
  IconBriefcase,
  IconCalculator,
  IconTrain,
} from '@tabler/icons-react';
import { Badge, Menu, MenuProps } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { UPermissionsName } from 'app/railways/domains/access/core/permissions';
import { useUserProfileStore } from 'app/railways/domains/profile/features/user-profile-data';
// import { withPerm } from 'app/railways/domains/access/features/permissions/with-perm';
import { railwayAppRoute } from 'app/router/routes';
import { appRoute } from 'app/terminals/router/routes';

const defaultOpenKeys = ['employees', 'profiles', 'devices'];

// const SubMenu = withPerm(Menu.SubMenu);
// const SubMenu = Menu.SubMenu;
// const MenuItem = withPerm(Menu.Item);
// const MenuItem = Menu.Item;

const selectedKeys: string[] | undefined = [];

const menuItems: ({
  withPerm,
}: {
  withPerm: (perm: UPermissionsName, item: ItemType) => ItemType | null;
}) => MenuProps['items'] = ({ withPerm }) => [
  withPerm('PERM_TERMINAL_READ', {
    key: 'devices',
    label: 'Терминалы',
    icon: <IconCalculator size="16px" stroke="2" />,
    children: [
      withPerm('PERM_TERMINAL_READ', {
        key: 'devices-all',
        label: (
          <Link to={appRoute.TERMINALS.path}>
            <Badge status="default" text="Все терминалы" />
          </Link>
        ),
      }),
      withPerm('PERM_TERMINAL_CREATE', {
        key: 'devices-add',
        label: (
          <Link to={appRoute.TERMINALS.ADD.path}>
            <Badge status="default" text="Добавить терминал" />
          </Link>
        ),
      }),
    ],
  }),

  withPerm('PERM_TERMINAL_PROFILE_READ', {
    key: 'profiles',
    label: 'Профили терминалов',
    icon: <IconAddressBook size="16px" stroke="2" />,
    children: [
      withPerm('PERM_TERMINAL_PROFILE_READ', {
        key: 'profiles-all',
        label: (
          <Link to={appRoute.PROFILES.path}>
            <Badge status="default" text="Все профили" />
          </Link>
        ),
      }),
      withPerm('PERM_TERMINAL_PROFILE_CREATE', {
        key: 'profiles-add',
        label: (
          <Link to={appRoute.PROFILES.ADD.path}>
            <Badge status="default" text="Добавить профиль" />
          </Link>
        ),
      }),
    ],
  }),

  withPerm('PERM_EMPLOYEE_READ', {
    key: 'employees',
    label: 'Сотрудники',
    icon: <IconBriefcase size="16px" stroke="2" />,
    children: [
      withPerm('PERM_EMPLOYEE_READ', {
        key: 'employees-all',
        label: (
          <Link to={appRoute.EMPLOYEES.path}>
            <Badge status="default" text="Все сотрудники" />
          </Link>
        ),
      }),
      withPerm('PERM_EMPLOYEE_CREATE', {
        key: 'employees-add',
        label: (
          <Link to={appRoute.EMPLOYEES.ADD.path}>
            <Badge status="default" text="Добавить сотрудника" />
          </Link>
        ),
      }),
    ],
  }),
  {
    key: 'railways',
    icon: <IconTrain size="16px" stroke="2" />,
    label: <Link to={railwayAppRoute.path}>Поезда</Link>,
  },
];

export const SideMenu = observer(() => {
  const userProfileStore = useUserProfileStore();
  const withPerm = (perm: UPermissionsName, item: ItemType) =>
    userProfileStore.perms.has(perm) ? item : null;
  return (
    <Menu
      theme="light"
      mode="inline"
      defaultOpenKeys={defaultOpenKeys}
      selectedKeys={selectedKeys}
      triggerSubMenuAction="click"
      items={menuItems({ withPerm })}
    >
      {/* <SubMenu
        key="employees"
        title="Сотрудники"
        icon={<IconBriefcase size="16px" stroke="2" />}
        perm="PERM_PERSON_READ"
      >
        <MenuItem key="employees-all" perm="PERM_PERSON_READ">
          <Link to={appRoute.EMPLOYEES.path}>
            <Badge status="default" text="Все сотрудники" />
          </Link>
        </MenuItem>
        <MenuItem key="employees-add" perm="PERM_PERSON_CREATE">
          <Link to={appRoute.EMPLOYEES.ADD.path}>
            <Badge status="default" text="Добавить сотрудника" />
          </Link>
        </MenuItem>
      </SubMenu> */}
    </Menu>
  );
});
